/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

// src/dashRoutes.js

import React from "react";

import Dashboard from "views/Dashboard/Dashboard";
import Araclar from "views/Dashboard/Araclar";
import Faturalar from "views/Dashboard/Faturalar";
import AbonelikYonetimi from "views/Dashboard/AbonelikYonetimi";
import Hesaplar from "views/Dashboard/Hesaplar";
import Telemetri from "views/Dashboard/Telemetri";   // ✅ Telemetri import edildi
import StokYonetimi from "views/Dashboard/StokYonetimi";   // ✅ Telemetri import edild
import SimYonetimi from "views/Dashboard/SimYonetimi";
import PotansiyelMusteri from "views/Dashboard/PotansiyelMusteri";
import SatisSonrasi from "views/Dashboard/SatisSonrasi";
import BayiYonetimi from "views/Dashboard/BayiYonetimi";
import Yetkilendirme from "views/Dashboard/Yetkilendirme";
import Raporlar from "views/Dashboard/Raporlar";
import SunucuYonetimi from "views/Dashboard/SunucuYonetimi";


import {
  FiHome,
  FiTruck,
  FiCreditCard,
  FiRefreshCw,
  FiBookOpen,
  FiActivity,
  FiPackage,
  FiCpu,
  FiUsers,
  FiUserCheck,
  FiTool,
  FiBarChart,
  FiServer,
} from "react-icons/fi";

const dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <FiHome size={18} />,
    component: Dashboard,
    layout: "/admin",
    allowedRoles: ["admin", "bayi"], // Teknik personel göremez
  },
  {
    path: "/araclar",
    name: "Araçlar",
    icon: <FiTruck size={18} />,
    component: Araclar,
    layout: "/admin",
    allowedRoles: ["admin", "bayi", "teknik_eleman"], // Tüm roller görebilir
  },
  {
    path: "/faturalar",
    name: "Faturalama",
    icon: <FiCreditCard size={18} />,
    component: Faturalar,
    layout: "/admin",
    allowedRoles: ["admin"], // Sadece admin görebilir
  },
  {
    path: "/abonelik-yonetimi",
    name: "Abonelik Yönetimi",
    icon: <FiRefreshCw size={18} />,
    component: AbonelikYonetimi,
    layout: "/admin",
    allowedRoles: ["admin", "bayi"], // Teknik personel göremez
  },
  {
    path: "/hesaplar",
    name: "Hesaplar",
    icon: <FiBookOpen size={18} />,
    component: Hesaplar,
    layout: "/admin",
    allowedRoles: ["admin", "bayi"], // Teknik personel göremez
  },
  {
    path: "/telemetri",
    name: "Telemetri Yönetimi",
    icon: <FiActivity size={18} />,
    component: Telemetri,
    layout: "/admin",
    allowedRoles: ["admin", "bayi", "teknik_eleman"], // Tüm roller görebilir
  },
  {
    path: "/stok-yonetimi",
    name: "Stok Yönetimi",
    icon: <FiPackage size={18} />,
    component: StokYonetimi,
    layout: "/admin",
    allowedRoles: ["admin", "bayi", "teknik_eleman"], // Sadece saas_bayi görebilir (bayi için kontrol Sidebar'da)
  },
  {
    path: "/sim-yonetimi",
    name: "Sim Yönetimi",
    icon: <FiCpu size={18} />,
    component: SimYonetimi,
    layout: "/admin",
    allowedRoles: ["admin", "bayi"], // Sadece admin ve saas_bayi görebilir (bayi için kontrol Sidebar'da)
  },
  {
    collapse: true,
    name: "CRM (Destek)",
    icon: <FiUsers size={18} />,
    allowedRoles: ["admin"], // Sadece admin görebilir
    views: [
      {
        path: "/crm/potansiyel-musteri",
        name: "Potansiyel Müşteri",
        component: PotansiyelMusteri,
        layout: "/admin",
        allowedRoles: ["admin"],
      },
      {
        path: "/crm/satis-sonrasi",
        name: "Satış Sonrası",
        component: SatisSonrasi,
        layout: "/admin",
        allowedRoles: ["admin"],
      },
    ],
  },
  {
    path: "/bayi-yonetimi",
    name: "Bayi Yönetimi",
    icon: <FiUserCheck size={18} />,
    component: BayiYonetimi,
    layout: "/admin",
    adminOnly: true, // Sadece admin görecek
  },
  {
    path: "/yetkilendirme",
    name: "Yetkilendirme",
    icon: <FiTool size={18} />,
    component: Yetkilendirme,
    layout: "/admin",
    adminOnly: true, // Sadece admin görecek
  },
  {
    path: "/raporlar",
    name: "Raporlar",
    icon: <FiBarChart size={18} />,
    component: Raporlar,
    layout: "/admin",
    adminOnly: true, // Sadece admin görecek
  },
  {
    path: "/sunucu-yonetimi",
    name: "Sunucu Yönetimi",
    icon: <FiServer size={18} />,
    component: SunucuYonetimi,
    layout: "/admin",
    adminOnly: true, // Sadece admin görecek
  },
];

export default dashRoutes;
